module.exports = __webpack_public_path__ + "static/media/pieList@2x.8c43fb2c.png";